import { buttonVariant, heightStyle, roundStyle } from '@sds-system/constants';
import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledButtonProps } from './Button.types';

export const StyledButton = styled('button')<StyledButtonProps>(
  ({ isRound, size, theme, variant = 'solid.primary' }) => {
    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 'max-content',
      minWidth: 'max-content',
      height: theme.size[size],
      minHeight: theme.size[size],
      cursor: 'pointer',
      ...heightStyle[size],
      ...roundStyle[size],
      ...buttonVariant(theme)[variant],
      ...(isRound && {
        borderRadius: `${theme.borderRadius[999]}px !important`,
      }),
    };
  },
  ({ size }) => ({
    variants: [
      { props: { disabled: true }, style: { cursor: 'not-allowed' } },
      {
        props: { isRound: true },
        style: {
          paddingLeft: `${(heightStyle[size]?.paddingLeft as number) + 4}px`,
          paddingRight: `${(heightStyle[size]?.paddingRight as number) + 4}px`,
        },
      },
    ],
  }),
  getAllStyledProps,
);
